/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The event a dry run was evaluated against.
 * @export
 * @interface DryRunEvent
 */
export interface DryRunEvent {
    /**
     * 
     * @type {string}
     * @memberof DryRunEvent
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DryRunEvent
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof DryRunEvent
     */
    owner: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DryRunEvent
     */
    belongsToDefinitionOwner: boolean;
}

/**
 * Check if a given object implements the DryRunEvent interface.
 */
export function instanceOfDryRunEvent(value: object): value is DryRunEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if ((!('belongsToDefinitionOwner' in (value as Record<string, any>)) && !('belongs_to_definition_owner' in (value as Record<string, any>))) || ((value as Record<string, any>)['belongsToDefinitionOwner'] === undefined && (value as Record<string, any>)['belongs_to_definition_owner'] === undefined)) return false;
    return true;
}

export function DryRunEventFromJSON(json: any): DryRunEvent {
    return DryRunEventFromJSONTyped(json, false);
}

export function DryRunEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): DryRunEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'owner': json['owner'],
        'belongsToDefinitionOwner': json['belongs_to_definition_owner'],
    };
}

export function DryRunEventToJSON(json: any): DryRunEvent {
    return DryRunEventToJSONTyped(json, false);
}

export function DryRunEventToJSONTyped(value?: DryRunEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'owner': value['owner'],
        'belongs_to_definition_owner': value['belongsToDefinitionOwner'],
    };
}

